// Cara: "Sizing guide" link beside the size option label (added by Claude, reversible).
// Opens the existing Sizing guide block's popup, so its image, styling and show/hide rule stay the same.
if (!window.__caraSizeGuide) {
  window.__caraSizeGuide = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-cara-size-guide]');
    if (!trigger) return;
    event.preventDefault();

    const section = trigger.closest('.shopify-section') || document;
    const originalLink = section.querySelector('[class^="ai-sizing-guide-link-"]');
    const modal = section.querySelector('[class^="ai-sizing-guide-modal-"]:not([class*="content"])');
    if (!originalLink || !modal) return;

    originalLink.click();

    // The block returns focus to its own (now hidden) link on close; send it back to this link instead.
    const observer = new MutationObserver(() => {
      if (!modal.classList.contains('active')) {
        observer.disconnect();
        const current = document.querySelector('[data-cara-size-guide]');
        current?.focus();
      }
    });
    observer.observe(modal, { attributes: true, attributeFilter: ['class'] });
  });
}
